import {CommandActionMenu} from '../../_components/CommandActionMenu/CommandActionMenu'
import {LogoActionMenu} from '../../_components/LogoActionMenu/LogoActionMenu'
import {
  findByContentType,
  findByIdWithSchema,
  GenericGroupSchema,
  type GenericContent,
} from '../../../../../brand/lib/types/contentful'
import {useGenericCtaAction} from '../../../../../brand/components/GenericCtaAction/use-generic-cta-action'

import styles from './HeroSection.module.css'

type Props = {
  content: GenericContent['fields']['content']
  variant: 'primary' | 'secondary'
}

// Renders the slide's CTA. The `id` of a GenericGroup picks the component it renders as.
export function HeroSlideCta({content, variant}: Props) {
  const downloadOptions = findByContentType(content, 'downloadOptions')
  const commandActionMenu = findByIdWithSchema(content, 'commandActionMenu', GenericGroupSchema)
  const logoActionMenu = findByIdWithSchema(content, 'logoActionMenu', GenericGroupSchema)

  const downloadCta = useGenericCtaAction(downloadOptions, {
    analytics: {tag: 'button', context: 'CTAs', location: 'hero'},
    variant,
  })

  return (
    <div className={styles.cta}>
      {downloadCta.action}
      {downloadCta.feedback}
      {commandActionMenu ? <CommandActionMenu component={commandActionMenu} location="hero" variant={variant} /> : null}
      {logoActionMenu ? <LogoActionMenu component={logoActionMenu} location="hero" variant={variant} /> : null}
    </div>
  )
}
